// ResetPage - public password reset (ticket c8a7452e). Renders before the auth
// wall via the /reset/<token> route in index.js, same pattern as /onboard/.
import React, { useState } from 'react';

const API = 'https://tcio-api.onrender.com';
const NAVY = '#0A2239';
const BLUE = '#0878E8';
const box = { maxWidth: 420, margin: '10vh auto', padding: '28px 26px', background: '#fff',
  borderRadius: 12, boxShadow: '0 2px 12px rgba(20,45,70,0.10)', fontFamily: 'Inter, system-ui, sans-serif' };
const input = { width: '100%', boxSizing: 'border-box', border: '1px solid #D8E3EE', borderRadius: 8,
  padding: '10px 12px', fontSize: 14, marginTop: 6 };
const btn = { width: '100%', marginTop: 16, padding: '11px 0', borderRadius: 8, border: 'none',
  cursor: 'pointer', fontWeight: 600, fontSize: 14, color: '#fff', background: BLUE };

export default function ResetPage({ token }) {
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [done, setDone] = useState(false);

  const submit = async () => {
    setErr('');
    if (pw.length < 8) { setErr('Password must be at least 8 characters.'); return; }
    if (pw !== pw2) { setErr('Passwords do not match.'); return; }
    setBusy(true);
    try {
      const r = await fetch(API + '/api/auth/reset-password', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password: pw }) });
      const j = await r.json().catch(() => ({}));
      if (r.ok && j.ok) setDone(true);
      else setErr(j.error || 'Reset failed. Request a new link from the login page.');
    } catch (e) { setErr('Network error. Try again.'); }
    setBusy(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#F4F8FB' }}>
      <div style={box}>
        <div style={{ fontWeight: 700, fontSize: 20, color: NAVY, marginBottom: 4 }}>TCIO</div>
        {done ? (
          <>
            <div style={{ fontSize: 15, color: '#169B62', fontWeight: 600, margin: '14px 0 6px' }}>Password updated.</div>
            <div style={{ fontSize: 13.5, color: '#5D6B7A' }}>You can now sign in with your new password.</div>
            <button style={btn} onClick={() => { window.location.href = '/'; }}>Go to sign in</button>
          </>
        ) : (
          <>
            <div style={{ fontSize: 15, color: '#22303E', fontWeight: 600, margin: '10px 0 2px' }}>Set a new password</div>
            <div style={{ fontSize: 12.5, color: '#5D6B7A', marginBottom: 12 }}>This link works once and expires 60 minutes after it was requested.</div>
            <label style={{ fontSize: 12, color: '#5D6B7A' }}>New password
              <input style={input} type="password" value={pw} onChange={e => setPw(e.target.value)} autoFocus /></label>
            <label style={{ fontSize: 12, color: '#5D6B7A', display: 'block', marginTop: 10 }}>Confirm password
              <input style={input} type="password" value={pw2} onChange={e => setPw2(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') submit(); }} /></label>
            {err && <div style={{ marginTop: 10, fontSize: 13, color: '#E5484D' }}>{err}</div>}
            <button style={{ ...btn, opacity: busy ? 0.6 : 1 }} disabled={busy} onClick={submit}>
              {busy ? 'Saving\u2026' : 'Set password'}</button>
          </>
        )}
      </div>
    </div>
  );
}
